// React imports.
import React, { Component } from "react";

// App imports.
import { GuidedSearchReportTypes} from "../utility";


const StandardReports = ({ state }) => (
     <React.Fragment>
          This section of the Data Warehouse provides step-by-step guidance in developing specific data reports, tables, and charts that are helpful for understanding the performance of the LIHEAP Program. Three types of reports are available: single state reports, state comparison reports, and national reports.
          <div className="accordion md-accordion" id="accordionEx" role="tablist" aria-multiselectable="true">
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="headingTwo2">
                         <a href="#" onClick={clickEvent => { clickEvent.preventDefault(); state.reportTypeSelectedHandler(GuidedSearchReportTypes.singleState); }}>
                              <h5 className="mb-0">
                                   Single State Program Reports &mdash;
                                   Find information about each state’s LIHEAP program.
                              </h5>
                         </a>
                    </div>
               </div>
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="headingTwo2">
                         <a href="#" onClick={clickEvent => { clickEvent.preventDefault(); state.reportTypeSelectedHandler(GuidedSearchReportTypes.stateComparison); }}>
                              <h5 className="mb-0">
                                   State Comparison Reports &mdash; Compare LIHEAP programs among several states.
                              </h5>
                         </a>
                    </div>
               </div>
               <div className="card mt-3">
                    <div className="card-header" role="tab" id="headingTwo2">
                         <a href="#" onClick={clickEvent => { clickEvent.preventDefault(); state.reportTypeSelectedHandler(GuidedSearchReportTypes.nationalReports); }}>
                              <h5 className="mb-0">
                                   National LIHEAP Program Reports &mdash; Explore national LIHEAP program statistics.
                              </h5>
                         </a>
                    </div>
               </div>


               
          </div>
     </React.Fragment >
);

export default StandardReports;
